import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { ReactSelectClassName } from "components/Shared/MSelect";
import { Button, Checkbox } from "react-md";
import { cloneDeep } from "lodash";

const Option = ({ ...props }) => {
    return (
        <div>
            <components.Option {...props} className="react-select-option">
                <Checkbox
                    id="react-select-checkbox"
                    name="simple-checkboxes[]"
                    label={props.value}
                    checked={props.isSelected}
                    onChange={() => { }}
                />
            </components.Option>
        </div>
    );
};

const customStyles = {
    indicatorsContainer: () => ({
        display: "none",
    }),
    multiValue: () => ({
        display: "none",
    }),
    control: () => ({
        borderRadius: "0",
        borderBottom: "2px solid #C8102E",
        backgroundColor: "white",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#eee !important" :
            state.isFocused ? "rgba(0, 0, 0, 0.12) !important" : "white !important",      
    }),
};

const Input = ({ ...props }) => {
    return (
        <components.Input {...props} className="react-select-input" />
    );
};

class CheckBoxMultiSelect extends React.Component {
    constructor(props) {
        super(props);
        this.click = this.click.bind(this);
        this.arrToObj = this.arrToObj.bind(this);
        this.toggle = this.toggle.bind(this);
        this.getSelected = this.getSelected.bind(this);
        this.removeSelectAll = this.removeSelectAll.bind(this);
        this.checkSelectAllRemoved = this.checkSelectAllRemoved.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getFilterName = this.getFilterName.bind(this);
        this.getButtonText = this.getButtonText.bind(this);
        this.state = {
            filterName: this.getFilterName(),
            selected: this.getSelected(),
            display: false,
            selectAllMarked: this.props.title.find(t => t === "Select All") ? true : false,
            buttonText: this.getButtonText(),
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentDidUpdate() {
        if (this.state.display) {
            let currentMenu = document.querySelector(`.${this.props.term} .display-react-select-menu .react-select-input input`);
            currentMenu.focus();

            let inputDivs = document.querySelectorAll(".react-select-input input");
            inputDivs.forEach(function (inputDiv) {
                inputDiv.style.minWidth = "100px";
                inputDiv.placeholder = "Search";
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getSelected() {
        if (this.props.title.find(t => t === "Select All")) {
            return this.props.items.map(this.arrToObj);
        } else {
            return this.props.title.map(this.arrToObj);
        }
    }

    getFilterName() {
        let filterName;
        switch (this.props.term) {
            case "survey":
                filterName = "SURVEY TYPE";
                break;
            case "status":
                filterName = "STATUS";
                break;
            case "customer":
                filterName = "CUSTOMER";
                break;
            case "insuranceCustomerList":
                filterName = "CUSTOMER";
                break;
            case "lenderCustomerList":
                filterName = "CUSTOMER";
                break;
            case "status_valuation":
                filterName = "STATUS";
                break;
        }
        return filterName;
    }

    getButtonText() {
        let selected = this.getSelected();
        let options = this.props.items;
        let filterName = (selected.length > 1) ?
            ((this.getFilterName() === "STATUS") ?
            this.getFilterName() + "ES" : this.getFilterName() + "S") : this.getFilterName();
        if (selected.length === 0) {
            return `SELECT ${this.getFilterName()}`;
        }else if (selected.length === options.length) {
            return `ALL ${filterName}`;
        } else {
            return `${selected.length} ${filterName} SELECTED`;
        }
    }

    arrToObj(item) {
        const obj = { label: item, value: item };
        return obj;
    }

    click(values) {
        let selected;
        let selectAll;
        if (this.checkSelectAllRemoved(values)) {
            selected = [];
            selectAll = false;
        } else {
            if (values.find(title => title.label === "Select All")) selectAll = true;
            if (this.state.selectAllMarked) {
                selected = this.removeSelectAll(values);
                selectAll = false;
            } else {
                selected = values;
            }
        }
        this.setState({ selected: selected });
        this.setState({ selectAllMarked: selectAll });
        this.props.onChange({
            term: this.props.term,
            title: selected.map(s => s.label),
            code: selectAll ? "all" : "",
            id: ""
        });
    }

    checkSelectAllRemoved(values) {
        if ((values.length === this.props.items.length - 1)) {
            if (!values.find(x => x.label === "Select All") && this.state.selectAllMarked) {
                return true;
            }
        }
        return false;
    }

    removeSelectAll(values) {
        let newValues = cloneDeep(values);
        let selectAllObj = newValues.find(value => value.label === "Select All");
        let index = newValues.indexOf(selectAllObj);
        if (index > -1) newValues.splice(index, 1);
        return newValues;
    }

    toggle() {
        let toggledState = !this.state.display;
        this.setState({ display: toggledState });
    }

    onBlur() {
        setTimeout(() => {
            if (this._isMounted) {
                this.setState({ display: false });
            }
        }, 200);
    }

    render() {
        return (
            <div className={this.props.term}>
                <Button id="menu-button-3-toggle" raised iconChildren="arrow_drop_down" onClick={this.toggle}>{this.state.buttonText.toLowerCase()}</Button>
                <div className={this.state.display ? "display-react-select-menu" : "display-react-select-menu-none"} onBlur={this.onBlur}>
                    <Select
                        className={ReactSelectClassName}
                        classNamePrefix="react-select"
                        closeMenuOnSelect={false}
                        isMulti
                        components={{ Option, Input }}
                        options={this.props.items.map(this.arrToObj)}
                        hideSelectedOptions={false}
                        backspaceRemovesValue={false}
                        onChange={this.click}
                        value={this.state.selected}
                        defaultValue={this.state.selected}
                        menuIsOpen
                        placeholder=""
                        isClearable={false}
                        styles={customStyles}
                    />
                </div>
            </div>
        );
    }
}

Option.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired
};

CheckBoxMultiSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    title: PropTypes.array.isRequired,
    items: PropTypes.array.isRequired,
    term: PropTypes.string.isRequired,
};

export default CheckBoxMultiSelect;